'use strict'

//import firebase from "firebase/database"
import firebase from "firebase"

export default class Team {

    constructor() {
        this.ownerId
        this.name
        this.teamKey
        this.calendarId
        this.apiKey
        /** ex) -540 */
        this.timezoneOffset
        this.timestamp
    }

    static findByKey(teamKey) {
        return new Promise(function(resolve, reject) {
            // console.info('mode : ' + process.env.NODE_ENV)
            // if (process.env.NODE_ENV == 'development') {
            //     resolve(Team.createDummyModel())
            //     return
            // }

            firebase.database().ref('keys').child(teamKey).once('value').then(function(data) {
                if (data.exists()) {
                    var ownerId = data.val()
                    firebase.database().ref('teams').child(ownerId).once('value').then(function(data) {
                        var model = Team.createModel(ownerId, data)
                        resolve(model)
                    })
                    .catch(function(error) {
                        reject(error)
                    })
                }
                else {
                    resolve(null)
                }
            })
            .catch(function(error) {
                reject(error)
            })
        })
    }

    /**
     * find by teamKey.
     * 
     * @param String key unique TeamKey.
     * @param function foundFunc callback function. first arguement is found Team object. if not found then null.
     */
    static findByOwnerId(ownerId) {
        return new Promise((resolve, reject) => {
            firebase.database().ref('teams').child(ownerId).once('value').then((data) => {
                if (data.exists()) {
                    var team = Team.createModel(ownerId, data)
                    resolve(team)
                }
                else {
                    resolve(null)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    }

    register() {
        var that = this
        let data = {}

        data['team_key'] = that.teamKey

        if (that.name) {
            data['name'] = that.name
        }

        if (that.calendarId) {
            data['calendar_id'] = that.calendarId
        }
        
        that.timestamp = firebase.database.ServerValue.TIMESTAMP;
        data['timestamp'] = firebase.database.ServerValue.TIMESTAMP
        that.timezoneOffset = new Date().getTimezoneOffset();
        firebase.database().ref('teams').child(that.ownerId).set(data)

        // 転値インデックスも登録
        firebase.database().ref('keys').child(that.teamKey).set(that.ownerId)
    }

    update() {
        var that = this
        firebase.database().ref('teams/' + that.ownerId).set(
            {
                'team_key': that.teamKey,
                'name': that.name,
                'api_key': that.apiKey,
                'calendar_id': that.calendarId,
                'timezone_offset': that.timezoneOffset,
                'timestamp': firebase.database.ServerValue.TIMESTAMP
            }
        )
    }

    remove() {
        var that = this
        firebase.database().ref('teams').child(that.ownerId).remove()
        // 転値インデックスも登録
        firebase.database().ref('keys').child(that.teamKey).remove()
            .then(function() {
                console.log('remove team. [ownerId : ' + that.ownerId + ']')
            }
        )
    }


    static createModel(ownerId, data) {
        var team = new Team()
        team.ownerId = ownerId
        team.name = data.child('name').val()
        team.teamKey = data.child('team_key').val()
        team.apiKey = data.child('api_key').val()
        team.calendarId = data.child('calendar_id').val()
        team.timezoneOffset = data.child('timezone_offset').val()
        team.timestamp = data.child('timestamp').val()
        return team
    }

    static createDummyModel() {
        var team = new Team()
        team.ownerId = 'ownerId'
        team.name = 'name'
        team.teamKey = 'teamKey'
        team.apiKey = 'apiKey'
        team.calendarId = 'calendarId'
        team.timezoneOffset = 'timezoneOffset'
        team.timestamp = 'timestamp'
        return team
    }
}